export const currencyFormatter = new Intl.NumberFormat('it-IT', {
  style: 'currency',
  currency: 'EUR',
  maximumFractionDigits: 2,
});

export const compareTime = (baseDate: string, compareDate?: string | null): boolean => {
  if (!compareDate) {
    return false;
  }

  const baseTime = baseDate.split('T')[1].split(':');
  const compareTime = compareDate.split('T')[1].split(':');

  return baseTime[0] + ':' + baseTime[1] === compareTime[0] + ':' + compareTime[1];
};
